var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1332_6737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 1.66667V15H1.66667V1.66667H18.3333ZM18.9583 0H1.04167C0.765399 0 0.500447 0.109747 0.305097 0.305097C0.109747 0.500447 0 0.765399 0 1.04167L0 15.625C0 15.9013 0.109747 16.1662 0.305097 16.3616C0.500447 16.5569 0.765399 16.6667 1.04167 16.6667H18.9583C19.0951 16.6667 19.2306 16.6397 19.357 16.5874C19.4833 16.535 19.5982 16.4583 19.6949 16.3616C19.7916 16.2648 19.8684 16.15 19.9207 16.0236C19.9731 15.8972 20 15.7618 20 15.625V1.04167C20 0.904873 19.9731 0.769419 19.9207 0.643038C19.8684 0.516657 19.7916 0.401825 19.6949 0.305097C19.5982 0.208369 19.4833 0.131641 19.357 0.0792921C19.2306 0.0269434 19.0951 0 18.9583 0V0Z",
    fill: "#84B0DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1436 4.19791L10.3602 9.90208C10.2476 9.99671 10.1052 10.0486 9.95815 10.0486C9.81106 10.0486 9.66868 9.99671 9.55607 9.90208L2.7769 4.21458C2.71452 4.16123 2.66326 4.09612 2.62604 4.02296C2.58882 3.9498 2.56638 3.87003 2.56 3.7882C2.55361 3.70636 2.56341 3.62407 2.58883 3.54603C2.61425 3.46798 2.6548 3.39571 2.70815 3.33333L2.9769 3.01458C3.08341 2.888 3.23575 2.8088 3.40055 2.79435C3.56535 2.7799 3.72916 2.83138 3.85607 2.9375L9.94982 8.05833L16.0727 2.91667C16.1994 2.8103 16.363 2.75847 16.5278 2.77253C16.6926 2.78658 16.8451 2.86539 16.9519 2.99167L17.2207 3.31041C17.2745 3.37347 17.3152 3.4466 17.3405 3.52556C17.3658 3.60451 17.3752 3.68771 17.368 3.77031C17.3608 3.8529 17.3373 3.93325 17.2987 4.00666C17.2602 4.08007 17.2075 4.14509 17.1436 4.19791V4.19791Z",
    fill: "#84B0DA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1332_6737"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 16.6667,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.8c57c79d542462b96b143b3cb1b3c0ce.svg";
export { ForwardRef as ReactComponent };